// Staging
export const msalConfig = {
  // Replace 'your_client_id' with your Azure AD app's client ID
  auth: {
    clientId: '94119560-80c7-4c63-99c6-5a98d9907181', // This is the ONLY mandatory field that you need to supply.
    authority: 'https://iccdevlogin.b2clogin.com/iccdevlogin.onmicrosoft.com/B2C_1A_SIGNINSIGNUP', // Choose SUSI as your default authority.
    knownAuthorities: ['iccdevlogin.b2clogin.com'], // Mark your B2C tenant's domain as trusted.
    redirectUri: '/', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: true // If "true", will navigate back to the original request location before processing the auth code response.
    // when using true, this is not even necessary to add the request_uri as the state in the authScopes
  },
  cache: {
    cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: true // Set this to "true" if you are having issues on IE11 or Edge
  }
};

// Production
export const msalConfigProd = {
  auth: {
    clientId: '898d0315-5b27-4b48-a566-83ec02a66d38',
    authority:
      'https://accounts.icc-cricket.com/4ba9f276-2497-440e-a6ba-d05d4831b967/B2C_1A_SIGNINSIGNUP',
    knownAuthorities: ['accounts.icc-cricket.com'],
    redirectUri: '/top-picks/',
    postLogoutRedirectUri: '/top-picks/',
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true
  }
};
